import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ADD_MESSAGE_SUCCESS, INBOX_FETCH_SUCCESS, INBOX_FETCH_ERROR, DELETE_MESSAGE, RECEIVE_SOCKET_MESSAGE, RECEIVE_MESSAGE_LOADING, RECEIVE_SOCKET_GROUP_MESSAGE } from "../Reducer/userInboxReducer";
import { POST_FETCH_COMMENT_ADDON, ADD_POST_FETCH_SUCCESS, POST_LIKE_UPDATE } from "../Reducer/postReducer";
import { MESSAGE_FETCH_ECHO } from '../Reducer/messageReducer';
import NewMessage from '../assets/audio/NewMessage.mp3';
import NotificationSound from '../assets/audio/notification.mp3';
import NewPostSound from '../assets/audio/NewPost.mp3';
import Agent from '../Network/Agent';
import { toast } from 'react-toastify';
import PopupNewPost from '../Props/PopupNewPost';
import CallPopup from '../Props/CallPopup';
import API from "../Network/API";
import { ADD_FPOST_FETCH_SUCCESS, FPOST_FETCH_COMMENT_ADDON, FPOST_LIKE_UPDATE } from "../Reducer/friendProfileReducer";
import { SINGLE_POST_FETCH_COMMENT_ADDON, SINGLE_POST_LIKE_UPDATE } from "../Reducer/singlePostReducer";
import { ACTIVE_Notify_FETCH_START, ADD_Notify_SUCCESS } from "../Reducer/ActiveNotifyReducer";
import { ACTIVE_MEETING_FETCH_START, ADD_MEETING_START_SUCCESS } from "../Reducer/MeetingStartReducer";
import { FRIEND_REQUEST_RECEIVED } from "../Reducer/friendRequestReducer";
import { MEETING_STATUS_UPDATED, MEETING_RSVP_UPDATED, MEETING_INVITE_RECEIVED } from "../Reducer/UpcomingMeetingReducer";



function Realtime() {

    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [showIncomingCall, setShowIncomingCall] = useState(false);
    const [profilePhoto, setProfilePhoto] = useState('');
    const [callerAvatar, setCallerAvatar] = useState('');
    const [callData, setCallData] = useState('');
    const [callerName, setCallerName] = useState('');
    const [callId, setCallId] = useState('');
    const [profileId, setProfileId] = useState('');
    const [pId, setPid] = useState(0);
    let location = useLocation();

    const [playing, setPlaying] = useState(false);
    const audioRef = useRef(null);
    const navigate = useNavigate();
    const myArr = JSON.parse(localStorage.getItem('user_data') || 'null');

    const selector = useSelector((state) => state.settingsReducer);
    const settingsData = selector?.data;

    const idd = location.pathname.split('/');

    const playIncomingCall = () => {
        if (!audioRef.current) {
            audioRef.current = new Audio('/assets/audio/IncomingCall.mp3');
            audioRef.current.loop = true;
        }
        setPlaying(true);
        audioRef.current.play().catch(() => {});
    };

    const pauseIncomingCall = () => {
        if (audioRef.current) {
            setPlaying(false);
            audioRef.current.pause();
        }
    };

    const playSound = () => {
        const audio = new Audio(NewMessage);
        audio.addEventListener('canplaythrough', () => {
            audio.play().catch(() => {}); // Silently handle autoplay restriction
        });
    };

    const playNewPostSound = () => {
        const audio = new Audio(NewPostSound);
        audio.addEventListener('canplaythrough', () => {
            audio.play().catch(() => {});
        });
    };

    const playSoundNotification = () => {
        const audio = new Audio(NotificationSound);
        audio.addEventListener('canplaythrough', () => {
            audio.play().catch(() => {});
        });
    };


    useEffect(() => {
        setTimeout(() => {
            setShowPopup(false);
        }, 10000);
    }, [profileId]);

    useEffect(() => {
        setTimeout(() => {
            setShowIncomingCall(false);
        }, 30000);
    }, [callId]);

    const chatReducer = useSelector((state) => state.ChatListId)

    useEffect(() => {
        setPid(chatReducer.chat_id)
        localStorage.setItem("user_id", chatReducer.chat_id);
    }, [chatReducer.chat_id]);

    useEffect(() => {

        setTimeout(() => {
            const user = JSON.parse(localStorage.getItem("user_data"));

            // Don't subscribe to WebSocket channels if user is not logged in
            if (!user || !user.id) return;

            window.Echo.private(`App.User.${user.id}`)
                .subscribed(() => {
                    // console.log('subscribed to post comments' + user['id']);
                })
                .listen('PostCommentEvent', (e) => {
                    dispatch(POST_FETCH_COMMENT_ADDON(e.data));
                    dispatch(FPOST_FETCH_COMMENT_ADDON(e.data));
                    dispatch(SINGLE_POST_FETCH_COMMENT_ADDON(e.data));
                }).listen('PostEvent', (e) => {
                    setProfilePhoto(e.data.avatar);
                    setShowPopup(true);
                    setProfileId(e.data.id);
                    playNewPostSound();
                    dispatch(ADD_POST_FETCH_SUCCESS(e.data));
                    dispatch(ADD_FPOST_FETCH_SUCCESS(e.data));
                }).listen('PostLoveEvent', (e) => {
                    dispatch(POST_LIKE_UPDATE(e));
                    dispatch(FPOST_LIKE_UPDATE(e));
                    dispatch(SINGLE_POST_LIKE_UPDATE(e));
                }).listen('IncomingCall', (e) => {
                    setCallerAvatar(e.avatar);
                    setCallId(e.data.id);
                    setCallerName(e.caller);
                    // Include callType in callData for later use
                    setCallData({ ...e.data, callType: e.callType });
                    handleIncomingCall(e.data.id);
                    setShowIncomingCall(true);
                    playIncomingCall();
                }).listen('CallAccept', (e) => {
                    // Dismiss outgoing call UI in UserInbox
                    window.dispatchEvent(new CustomEvent('call-accepted'));
                    // Caller navigates to LiveKit call page with their pre-stored token
                    const audioOnly = (callData?.callType === '0' || callData?.callType === 0 ||
                        window._outgoingCallType === '0') ? '1' : '0';
                    // Use stored token, fall back to caller JWT from event data
                    const callerToken = window._outgoingCallToken || e.data?.jwt || '';
                    const livekitUrl = window._outgoingCallLivekitUrl || 
                        (window.location.protocol === 'https:' 
                            ? `wss://${window.location.hostname}:7443` 
                            : `ws://${window.location.hostname}:7880`);
                    const roomName = e.data.room_id;
                    // Get callee name from the outgoing call context
                    const calleeName = window._outgoingCallName || 'Unknown';
                    window._outgoingCallType = null;
                    window._outgoingCallToken = null;
                    window._outgoingCallLivekitUrl = null;
                    window._outgoingCallName = null;
                    navigate(`/livekit-call?room=${roomName}&token=${encodeURIComponent(callerToken)}&url=${encodeURIComponent(livekitUrl)}&audioOnly=${audioOnly}&callingId=${e.data.id}&callerName=${encodeURIComponent(calleeName)}`);
                }).listen('CallRinging', (e) => {
                    console.log('CallRinging', e.data);
                }).listen('CallReject', (e) => {
                    console.log('CallReject', e.data);
                    // Dismiss outgoing call UI in UserInbox
                    window.dispatchEvent(new CustomEvent('call-rejected'));
                    toast.info('Call was declined');
                }).listen('CallCancel', (e) => {
                    // Caller cancelled — stop ringing for the callee
                    setShowIncomingCall(false);
                    pauseIncomingCall();
                    toast.info('Call was cancelled');
                })
                .listen('MeetingStartEvent', (e) => {
                    dispatch(ACTIVE_MEETING_FETCH_START());
                    dispatch(ADD_MEETING_START_SUCCESS(e.data));
                })
                .listen('MeetingStatusChanged', (e) => {
                    // Real-time meeting start/end push from Soketi
                    dispatch(MEETING_STATUS_UPDATED(e));
                })
                .listen('.MeetingRsvpUpdated', (e) => {
                    // Invitee RSVP'd — patch the host's participant list in real-time
                    dispatch(MEETING_RSVP_UPDATED(e));

                    // Show a colored toast to the host
                    const statusColors = { accept: '#16a34a', maybe: '#f59e0b', reject: '#ef4444' };
                    const statusLabels = { accept: 'Accepted', maybe: 'Maybe', reject: 'Declined' };
                    const color = statusColors[e.status] || '#6b7280';
                    const label = statusLabels[e.status] || e.status_label || e.status;
                    const name  = e.invitee_name || 'Someone';
                    const title = e.meeting_title ? ` "${e.meeting_title}"` : '';
                    toast.info(
                        `${name} ${label.toLowerCase()} your meeting${title}`,
                        {
                            toastId: 'rsvp_' + e.meeting_id + '_' + e.invitee_id,
                            style: { borderLeft: `4px solid ${color}` },
                            autoClose: 5000,
                        }
                    );
                })
                .listen('.MeetingInviteReceived', (e) => {
                    // Host invited this user — trigger a meeting list refresh
                    dispatch(MEETING_INVITE_RECEIVED());

                    // Show a toast so the invitee knows right away
                    const host  = e.host_name    || 'Someone';
                    const title = e.meeting_title || 'a meeting';
                    toast.info(
                        `📅 ${host} invited you to "${title}"`,
                        { 
                            toastId: 'invite_' + e.meeting_id,
                            autoClose: 6000 
                        }
                    );
                })
                .notification((data) => {
                    if (settingsData?.allowNotificationSound == true) {
                        playSoundNotification();
                    }
                    Agent.Notification.latest(dispatch);
                    dispatch(ACTIVE_Notify_FETCH_START());
                    dispatch(ADD_Notify_SUCCESS(data));

                    // Friend request notification — trigger FriendRequestAccept re-fetch
                    if (data.type1 == 4) {
                        dispatch(FRIEND_REQUEST_RECEIVED());
                        Agent.HomeAgent.Suggest_Users(dispatch);
                    }

                    // 🎙️ Audio room went live — show clickable toast + refresh room list
                    if (data.type1 === 'audio_room') {
                        const roomId = data.app_url; // room ID stored in app_url
                        const title  = data.title   || '🎙️ Audio Room Live';
                        const host   = data.details  || 'Someone started a room';

                        // Dispatch a custom event so AudioRoom.js can re-fetch its lists
                        window.dispatchEvent(
                            new CustomEvent('audio-room-live', { detail: { roomId } })
                        );

                        // Show a clickable toast banner
                        toast(
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {data.avatar && (
                                    <img
                                        src={data.avatar}
                                        alt=""
                                        style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                    />
                                )}
                                <div>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#fff' }}>{title}</div>
                                    <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.8)', marginTop: 2 }}>{host}</div>
                                </div>
                                <button
                                    onClick={() => navigate(roomId ? `/audio-rooms/join/${roomId}` : '/audio-rooms')}
                                    style={{
                                        marginLeft: 'auto',
                                        background: 'rgba(255,255,255,0.2)',
                                        border: '1px solid rgba(255,255,255,0.4)',
                                        borderRadius: 8,
                                        color: '#fff',
                                        padding: '4px 10px',
                                        fontSize: 12,
                                        cursor: 'pointer',
                                        flexShrink: 0,
                                    }}
                                >
                                    Join →
                                </button>
                            </div>,
                            {
                                toastId: 'audio_room_' + roomId,
                                style: { background: '#6366f1', border: 'none', borderRadius: 12, padding: '10px 14px' },
                                autoClose: 8000,
                                closeOnClick: false,
                            }
                        );
                    }

                }).error((error) => {
                    // console.log("echo:error", error);
                });

            // App.User channel end

            window.Echo.private(`App.Chat.${user['id']}`)
                .subscribed(() => {
                })
                .listen('MessageSent', (e) => {
                    if (settingsData?.allowMessagingSound == true) {
                        playSound();
                    }
                    const tt = e.conversations;
                    const payload = {
                        last_message_id: tt.id,
                        name: tt.sender.name,
                        image: tt.sender.avatar,
                        to_id: tt.from_id,
                        is_group: tt.is_group,
                        message: tt.message,
                        url_details: tt.url_details,
                        seen_at: tt.seen_at,
                        last_messages: null,
                        is_online: tt.sender.is_online,
                        unread_count: 1,
                        created_at: tt.created_at,
                    }

                    dispatch(MESSAGE_FETCH_ECHO(payload))
                    if (tt.is_group == 0) {
                        if (tt.from_id == localStorage.getItem("user_id") && tt.to_id == myArr?.id) {
                            dispatch(RECEIVE_SOCKET_MESSAGE(e.conversations))
                        }
                    }

                }).listen('GroupMessageEvent', (e) => {
                    playSound();
                    const tt = e.conversations;
                    const payload = {
                        last_message_id: tt.id,
                        name: tt.receiver.name,
                        image: tt.receiver.avatar,
                        to_id: tt.to_id,
                        is_group: 1,
                        message: tt.message,
                        url_details: tt.url_details,
                        seen_at: tt.seen_at,
                        last_messages: null,
                        is_online: tt.sender.is_online,
                        unread_count: 1,
                        created_at: tt.created_at,
                    }

                    dispatch(MESSAGE_FETCH_ECHO(payload))

                    dispatch(RECEIVE_SOCKET_GROUP_MESSAGE(e.conversations))



                }).error((error) => {
                    // console.log("echo:error", error);
                }); //chat channel end
        }, 2500);

    }, []);

    function handleIncomingCall(incomingCallId) {
        API.put('update_calling/' + incomingCallId + '?status=1', {}).then((response) => {
            console.log('Incoming Call');
        }).catch((error) => {
            console.log(error);
        });
    }

    function callAccept() {
        setShowIncomingCall(false);
        pauseIncomingCall();
        // Use new LiveKit accept endpoint — returns fresh token
        API.post('v1/calls/' + callId + '/accept', {}).then((response) => {
            console.log('Call Accepted Success', response.data);
            const { token, livekit_url, room_name } = response.data;
            const audioOnly = callData?.callType === '0' || callData?.callType === 0 ? '1' : '0';
            navigate(`/livekit-call?room=${room_name}&token=${encodeURIComponent(token)}&url=${encodeURIComponent(livekit_url)}&audioOnly=${audioOnly}&callingId=${callId}&callerName=${encodeURIComponent(callerName || 'Unknown')}`);
        }).catch((error) => {
            console.log(error);
            toast.error('Failed to accept call');
        });
    }

    function callReject() {
        setShowIncomingCall(false);
        pauseIncomingCall();
        // Use new LiveKit reject endpoint
        API.post('v1/calls/' + callId + '/reject', {}).then((response) => {
            console.log('Call Rejected');
        }).catch((error) => {
            console.log(error);
        });
    }

    return (
        <>
            {showPopup &&
                location.pathname === "/" &&
                <PopupNewPost image={profilePhoto} />
            }

            {showIncomingCall &&
                <CallPopup onAccept={() => callAccept()} onClose={() => callReject()} image={callerAvatar} name={callerName} />
            }

        </>
    );

}

export default Realtime;